import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Switch, useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import RouteComponent from 'components/RouteComponent';

import {
  postEnrollmentRoutePaths,
  prefillDataEditRoutePaths,
} from 'consts/routeConsts';

import useRoutes from 'hooks/useRoutes';

import { selectIsEnrollmentCompleteStatus } from 'selectors/enrollment';
import { selectUserProgress } from 'selectors/user';

import resetEnrollment from 'thunks/resetEnrollment';

import { SocureSessionContext } from 'utils/socure';

const RouteWrapper = styled.div`
  ${props =>
    props.theme.media.mobileOnly`
      height: 100%;
  `};
`;

const RenderFormRoutes = () => {
  const dispatch = useDispatch();

  const userProgress = useSelector(selectUserProgress);
  const isEnrollmentComplete = useSelector(selectIsEnrollmentCompleteStatus);

  const history = useHistory();
  const location = useLocation();

  const {
    activeRouteFlow,
    userProgressIndex,
    getIndexOfPath,
    getFirstPathFromRouteFlow,
  } = useRoutes();

  const initialPagePath = userProgress || getFirstPathFromRouteFlow();

  /** Checks if user completed enrollment and is stepping back into the flow */
  useEffect(() => {
    redirectWhenEnrollmentCompleted();
  }, [location.pathname]);

  function redirectWhenEnrollmentCompleted() {
    const shouldResetEnrollment =
      !postEnrollmentRoutePaths.includes(location.pathname) &&
      isEnrollmentComplete;

    /** If the user
     * 1. Completed enrollment
     * 2. Got a success or decline response, and
     * 3. then tried to navigate back to the enrollment form,
     * we need to clear their session out and reset the application to a new
     * state before sending them back to step 1 of enrollment.
     */
    if (shouldResetEnrollment) {
      const firstPagePath = getFirstPathFromRouteFlow();

      dispatch(resetEnrollment());
      history.push(firstPagePath);
    }
  }

  function doRedirect() {
    const currentStep = location.pathname;
    const currentStepIndex = getIndexOfPath(currentStep);

    const stepNotRecognized =
      !currentStepIndex &&
      !postEnrollmentRoutePaths.includes(currentStep) &&
      !prefillDataEditRoutePaths.includes(currentStep);
    const isUserSteppingAhead = currentStepIndex > userProgressIndex;

    if (stepNotRecognized || isUserSteppingAhead) {
      return <Redirect to={initialPagePath} />;
    }

    return null;
  }

  const renderRoutes = () => {
    const routeComponents = activeRouteFlow.map(step => RouteComponent(step));

    return routeComponents;
  };

  return (
    <SocureSessionContext>
      <RouteWrapper>
        {doRedirect()}
        <Switch>{renderRoutes()}</Switch>
      </RouteWrapper>
    </SocureSessionContext>
  );
};

export default RenderFormRoutes;
